//deps
import React, { memo } from "react";
//internal-deps
import { CartTimer, CartTimerProps, useEffectOnce } from "@swiggy-private/core-ui";
// hooks
import useCartTimerFromStorage from "@cart-client/hooks/useCartTimer";

export interface CartTimerWrapperProps extends Omit<CartTimerProps, "duration"> {
    setCroutonVisibility: (croutonVisibility: boolean) => void;
}

function CartTimerWrapper({ setCroutonVisibility, ...props }: CartTimerWrapperProps) {
    const { isTimerValid, closeTimeInSeconds } = useCartTimerFromStorage();

    useEffectOnce(() => {
        setCroutonVisibility(isTimerValid);
        return () => {
            setCroutonVisibility(false);
        };
    });

    if (!isTimerValid) {
        return null;
    }

    return <CartTimer {...props} duration={closeTimeInSeconds} />;
}

export default memo(CartTimerWrapper);
